import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import BookingSuccess from "@/pages/BookingSuccess";
import BookingCancel from "@/pages/BookingCancel";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: {
              border: "3px solid #0B132B",
              borderRadius: "10px",
              boxShadow: "4px 4px 0 #0B132B",
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
          <Route path="/booking/cancel" element={<BookingCancel />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/account" element={<Account />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
